/* Shared "big day" math — used by the 💖 Days tab and by the page-level
   fireworks/banner when an occasion lands on today. */

export const pad = (n) => String(n).padStart(2, '0');
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const daysInMonth = (y, m0) => new Date(y, m0 + 1, 0).getDate();

export const ord = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

/* Next occurrence of an event (today counts as upcoming) plus how many times
   it will have happened by then. Day-of-month is clamped so a 31st or a
   Feb-29 anniversary still lands in short months / non-leap years. */
export function nextOccurrence(ev, today) {
  const [y, m, d] = ev.date.split('-').map(Number);
  const t0 = startOfDay(today);
  if (ev.repeat === 'monthly') {
    let yy = t0.getFullYear();
    let mm = t0.getMonth();
    let cand = new Date(yy, mm, Math.min(d, daysInMonth(yy, mm)));
    if (cand < t0) {
      mm += 1;
      if (mm > 11) {
        mm = 0;
        yy += 1;
      }
      cand = new Date(yy, mm, Math.min(d, daysInMonth(yy, mm)));
    }
    return { when: cand, nth: (cand.getFullYear() - y) * 12 + (cand.getMonth() - (m - 1)) };
  }
  if (ev.repeat === 'yearly') {
    let yy = t0.getFullYear();
    let cand = new Date(yy, m - 1, Math.min(d, daysInMonth(yy, m - 1)));
    if (cand < t0) {
      yy += 1;
      cand = new Date(yy, m - 1, Math.min(d, daysInMonth(yy, m - 1)));
    }
    return { when: cand, nth: cand.getFullYear() - y };
  }
  return { when: new Date(y, m - 1, d), nth: 0 };
}

export function decorate(ev, today) {
  const { when, nth } = nextOccurrence(ev, today);
  const days = Math.round((when - startOfDay(today)) / 86400000);
  if (days < 0) return { ...ev, when, nth, days: -days, kind: 'past' };
  return { ...ev, when, nth, days, kind: days === 0 ? 'today' : 'soon' };
}

/* "3rd monthiversary" / "1st anniversary" / null for one-offs */
export function occasionLabel(ev) {
  if (ev.repeat === 'monthly' && ev.nth > 0) return `${ord(ev.nth)} monthiversary`;
  if (ev.repeat === 'yearly' && ev.nth > 0) return `${ord(ev.nth)} anniversary`;
  return null;
}
